import { Nes }		from "ts-base/textual/nes";

import { Textual }	from "@v3/data/textual";

export type NonEmptyString	= Textual.Value<typeof NonEmptyString>;
export const NonEmptyString	= Textual.fromBase(Nes, "must be a non-empty string");
